import React from 'react';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Checkbox,
  Select,
  DatePicker,
  message,
  Modal,
} from 'antd/lib';
import { Form } from '@ant-design/compatible';
const { RangePicker } = DatePicker;
import { descargarCSV } from '../../administracion/funciones/descargarCSV';
import _ from 'lodash';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getCasosPorRangoFecha from '../../../graphql/querys/violenciaGenero/getCasosPorRangoFecha.graphql';
import getCantidadCasosViolenciaConFiltros from '../../../graphql/querys/violenciaGenero/getCantidadCasosViolenciaConFiltros.graphql';

@compose(graphql(getOrganismos, { name: 'organismos' }))
class ReporteCasos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      lista: [],
      cantidadCasos: 0,
      filtro: props.usuario.organismo._id,
      fechaInicial: moment().subtract(7, 'd'),
      fechaFinal: moment(),
      showCheckbox: false,
      reporteGeneral: false,
      rolAutorizado: false,
      openModal: false,
      loadingModal: false,
    };
  }

  componentDidMount() {
    const { usuario } = this.props;
    if (usuario.rol === 'DGJP_DIRECTOR' || usuario.rol === 'DGJP_EMPLEADO') {
      this.setState({
        showCheckbox: true,
        rolAutorizado: true,
      });
    }
  }

  buscarCasos = () => {
    // console.log("ENTRE A BUSCAR CASOS");
    this.setState({ loading: true });

    this.props.client
      .query({
        query: getCantidadCasosViolenciaConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicial,
          fechaFinal: this.state.fechaFinal,
          filtroOrganismo: this.state.reporteGeneral ? null : this.state.filtro,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('RESPUESTA cantidad casos', res.data);

        if (res.data.getCantidadCasosViolenciaConFiltros > 0) {
          this.setState({
            cantidadCasos: res.data.getCantidadCasosViolenciaConFiltros,
          });
          this.props.client
            .query({
              query: getCasosPorRangoFecha,
              variables: {
                fechaInicial: this.state.fechaInicial,
                fechaFinal: this.state.fechaFinal,
                idOrganismo: this.state.reporteGeneral
                  ? null
                  : this.state.filtro,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              // console.log('RESPUESTA CASOS REPORTE', res.data);

              this.setState({
                loading: false,
                lista: res.data.getCasosPorRangoFecha,
              });
              this.showModal();
            })
            .catch(err => {
              message.error('Error al buscar casos de violencia');
              console.log('ERROR A LA HORA DE OBTENER LOS CASOS DE VIOLENCIA');
              console.log('EL ERROR ES: ', err);
            });
        } else {
          this.setState({ loading: false });
          message.error('No se encontraron Casos en las fechas seleccionadas');
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE CASOS DE VIOLENCIA'
        );
        console.log('EL ERROR ES: ', err);
      });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.buscarCasos();
  };

  onChangeFechas = date => {
    if (date !== null) {
      this.setState({
        ...this.state,
        fechaInicial: date[0] ? date[0] : '',
        fechaFinal: date[1] ? date[1] : '',
      });
    }
  };

  cambiarOrganismo = idOrganismo => {
    // console.log('Voy a cambiar el organismo: ', idOrganismo);
    this.setState({
      ...this.state,
      filtro: idOrganismo,
    });
  };

  handleCheckboxChange = () => {
    if (this.state.reporteGeneral) {
      this.setState({
        reporteGeneral: false,
        filtro: this.props.usuario.organismo._id,
      });
    } else {
      this.setState({
        reporteGeneral: true,
      });
    }
  };

  descargarReporte = async () => {
    // console.log('ENTRE A DESCARGAR REPORTE');
    this.setState({ loadingModal: true });

    let data = _.map(this.state.lista, caso => {
      let objeto = {
        fecha: moment(caso.fecha).format('DD.MM.YYYY'),
        organismo: caso.organismo.nombre,
        numero: caso.numero,
        ['denunciante']:
          caso.denunciante.nombre && caso.denunciante.apellido
            ? caso.denunciante.nombre + ' ' + caso.denunciante.apellido
            : 'sin datos',
        ['denunciante sexo']: caso.denunciante.sexo
          ? caso.denunciante.sexo
          : 'sin datos',
        ['denunciante tipo documento']: caso.denunciante.tipo_doc
          ? caso.denunciante.tipo_doc
          : 'sin datos',
        ['denunciante documento']: caso.denunciante.num_doc
          ? caso.denunciante.num_doc
          : 'sin datos',
        ['victima']:
          caso.victima.nombre && caso.victima.apellido
            ? caso.victima.nombre + ' ' + caso.victima.apellido
            : 'sin datos',
        ['victima sexo']: caso.victima.sexo ? caso.victima.sexo : 'sin datos',
        ['victima tipo documento']: caso.victima.tipo_doc
          ? caso.victima.tipo_doc
          : 'sin datos',
        ['victima documento']: caso.victima.num_doc
          ? caso.victima.num_doc
          : 'sin datos',
      };

      caso.agresores.map((agresor, i) => {
        objeto['agresor ' + (i + 1)] =
          agresor.nombre && agresor.apellido
            ? agresor.nombre + ' ' + agresor.apellido
            : 'sin datos';
        objeto['agresor ' + (i + 1) + ' sexo'] = agresor.sexo
          ? agresor.sexo
          : 'sin datos';
        objeto['agresor ' + (i + 1) + ' tipo documento'] = agresor.tipo_doc
          ? agresor.tipo_doc
          : 'sin datos';
        objeto['agresor ' + (i + 1) + ' documento'] = agresor.num_doc
          ? agresor.num_doc
          : 'sin datos';
      });

      return objeto;
    });
    await descargarCSV(
      [
        'FECHA',
        'ORGANISMO',
        'NUMERO',
        'DENUNCIANTE',
        'DENUNCIANTE SEXO',
        'DENUNCIANTE DOC',
        'VICTIMA',
        'VICTIMA SEXO',
        'VICTIMA DOC',
        'AGRESOR',
        'AGRESOR SEXO',
        'AGRESOR DOC',
      ],
      data,
      `ReporteCasosViolenciaDeGenero-${moment(this.state.fechaInicial).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFinal).format('DD/MM/YYYY')}.csv`
    );

    this.setState({ loadingModal: false, openModal: false });
  };

  handleCancelModal = () => {
    this.setState({ openModal: false });
  };

  showModal = () => {
    this.setState({ openModal: true });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    const { usuario } = this.props;

    return (
      <>
        <h2 style={{ textAlign: 'center', marginTop: 120 }}>
          Reporte Casos de Violencia de Genero
        </h2>

        <Form
          style={{ marginTop: 80 }}
          encType="multipart/form-data"
          onSubmit={this.handleSubmit}
        >
          <Row>
            <Col span={10} style={{ textAlign: 'center', margin: 'auto' }}>
              <Row>
                <Col span={5}>
                  <h3>FECHAS: </h3>
                </Col>
                <Col span={10}>
                  <RangePicker
                    style={{ width: 350, marginLeft: 10 }}
                    onChange={this.onChangeFechas}
                    defaultValue={[
                      this.state.fechaInicial,
                      this.state.fechaFinal,
                    ]}
                    format={'DD-MM-YYYY'}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row style={{ marginTop: 30 }}>
            <Col span={10} style={{ margin: 'auto' }}>
              <Row>
                <Col span={5}>
                  <h3>ORGANISMO: </h3>
                </Col>
                <Col span={10}>
                  <Select
                    style={{ width: 350, marginLeft: 10 }}
                    required
                    id="tipoDoc"
                    placeholder="Seleccione un organismo"
                    onSelect={valor => this.cambiarOrganismo(valor)}
                    disabled={
                      this.state.reporteGeneral || !this.state.rolAutorizado
                    }
                    defaultValue={usuario.organismo._id}
                  >
                    {this.props.organismos.getOrganismos &&
                      this.props.organismos.getOrganismos.map(organismo => (
                        <Select.Option
                          key={organismo._id}
                          value={organismo._id}
                        >
                          {organismo.nombre}
                        </Select.Option>
                      ))}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
          {this.state.showCheckbox && (
            <Row>
              <Col style={{ margin: 'auto', marginTop: 20 }}>
                <Checkbox
                  onChange={this.handleCheckboxChange}
                  checked={this.state.reporteGeneral}
                >
                  Incluir todos los Organismos
                </Checkbox>
              </Col>
            </Row>
          )}
          <Row style={{ marginTop: 30, marginBottom: 100 }}>
            <Col style={{ margin: 'auto' }}>
              <Button type="primary" htmlType="submit">
                Generar Reporte
              </Button>
            </Col>
          </Row>
        </Form>
        <Modal
          title="Reporte Casos de Violencia de Genero"
          visible={this.state.openModal}
          onOk={this.descargarReporte}
          confirmLoading={this.state.loadingModal}
          onCancel={this.handleCancelModal}
          footer={[
            <Button key="back" onClick={this.handleCancelModal}>
              Volver
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={this.state.loadingModal}
              onClick={this.descargarReporte}
            >
              Descargar Reporte
            </Button>,
          ]}
        >
          <p>{`Se encontraron ${this.state.cantidadCasos} casos de Violencia`}</p>
        </Modal>
      </>
    );
  }
}

export default withApollo(ReporteCasos);
